import { useLazyQuery } from '@apollo/client';
import React from 'react';

interface IDietSettingsValidateConnectorApolloProps {
  children: ({
    validateDietSettings,
  }: {
    validateDietSettings: (variables: any) => void;
  }) => React.ReactElement;
  query: any;
}

const DietSettingsValidateConnectorApollo: React.FC<IDietSettingsValidateConnectorApolloProps> = ({
  children,
  query,
}) => {
  const [validate] = useLazyQuery(query);

  const validateDietSettings = async (variables: any) => {
    const result = await validate({
      variables: variables,
      fetchPolicy: 'no-cache',
    });

    return result.data?.me.validateDietSettings;
  };
  return children({ validateDietSettings });
};

export default DietSettingsValidateConnectorApollo;
